const schemaContext = 'https://schema.org';

export const schemaOrgJSONLD = {
  '@context': schemaContext,
  '@type': 'Organization',
  name: 'Everly Health',
  legalName: 'Everly Health Solutions',
  url: 'https://www.everlywell.com/enterprise/',
  logo: 'https://www.everlywell.com/enterprise/images/',
  foundingDate: '2021',
  founders: [
    {
      '@type': 'Person',
      name: 'Julia Cheek',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: '823 Congress Ave, Suite 1200',
    addressLocality: 'Austin',
    addressRegion: 'Texas',
    postalCode: '78701',
    addressCountry: 'United States',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    telephone: '+1 (855) 422-3855',
    email: 'contact@everlyhealth.com',
  },
  sameAs: [
    'https://www.facebook.com/everlywell/',
    'https://twitter.com/everly_well',
    'https://www.pinterest.com/everlywell/',
    'https://www.linkedin.com/company/everlyhealth',
  ],
};

export const schemaWebPageJSONLD = (url: string, name: string) => [
  {
    '@context': schemaContext,
    '@type': 'WebPage',
    url: url,
    name: name,
  },
];
